/*
 * @Descripttion: 订单催付部分效果详情
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { Servlets } from '@/service';
import utils from '@/common/utils';
import { Button } from '@alifd/next';
import LzMsg from '@/components/common/LzMsg';
import LzPagination from '@/components/common/LzPagination';
import DataBox from '../dataBox';
import TableBox from '../tableBox';
import styles from './index.module.scss';
import moment from 'moment';

const ddcfSummary = ({form}, ref ) => {
  const { startTime = '', endTime = '', taskId = '' } = form;
  const [tableLoading1, setTableLoading1] = useState(false);
  // const [tableLoading2, setTableLoading2] = useState(false);
  const [data1, setData1] = useState<any>({
    careAmount: 0,
    careNum: 0,
    payAmount: 0,
    payNum: 0,
    reportDate: 0,
    roi: 0,
    successRate: 0,
  });
  // const [data2, setData2] = useState<any>({});
  // const [data3, setData3] = useState<any>({});
  const [table1, setTable1] = useState<any>([]);
  // const [table2, setTable2] = useState<any>([]);
  const [pageInfo1, setPageInfo1] = useState<any>({
    pageNo: 1,
    pageSize: 5,
    total: 0,
  });
  // const [pageInfo2, setPageInfo2] = useState<any>({
  //   pageNo: 1,
  //   pageSize: 5,
  //   total: 0,
  // });

  const getSummaryOne = async () => {
    Servlets('getOrderCareSummaryOne', {
      taskType: 'S_DDCF',
      startTime: startTime ? moment(startTime).startOf('day').valueOf() : '',
      endTime: endTime ? moment(endTime).endOf('day').valueOf() : '',
      taskId,
    }).then(res => {
      if (res.success) {
        setData1({ ...data1, ...res.data });
      } else {
        LzMsg.error(res.resp_msg);
      }
    })
  };

  // const getSummaryTwo = async () => {
  //   Servlets('getOrderCareSummaryTwo', {}).then(res => {
  //     if(res.success) {
  //       setData2({...res.data});
  //     } else {
  //       LzMsg.error(res.resp_msg);
  //     }
  //   })
  // };
  // const getSummaryThree = async () => {
  //   Servlets('getOrderCareSummaryThere', {}).then(res => {
  //     if(res.success) {
  //       setData2({...res.data});
  //     } else {
  //       LzMsg.error(res.resp_msg);
  //     }
  //   })
  // };

  const getTableOne = async (v) => {
    setTableLoading1(true);
    Servlets('getOrderCareTableOne', {
      taskType: 'S_DDCF',
      startTime: startTime ? moment(startTime).startOf('day').valueOf() : '',
      endTime: endTime ? moment(endTime).endOf('day').valueOf() : '',
      taskId,
      pageNo: pageInfo1.pageNo,
      pageSize: pageInfo1.pageSize,
      ...v
    }).then(res => {
      if (res.success) {
        setTable1([ ...res.data ]);
        setPageInfo1({ ...res.page });
        setTableLoading1(false);
      } else {
        LzMsg.error(res.resp_msg);
        setTableLoading1(false);
      }
    })
  };

  // const getTableTwo = async () => {
  //   setTableLoading2(true);
  //   Servlets('getOrderCareTableTwo', {}).then(res => {
  //     if(res.success) {
  //       setTable2({...res.data});
  //       setPageInfo2({...res.pageInfo});
  //       setTableLoading2(false);
  //     } else {
  //       LzMsg.error(res.resp_msg);
  //       setTableLoading2(false);
  //     }
  //   })
  // };

  const handlePageSizeChange1 = async (pages: object = {}) => {
    try {
      await getTableOne({ pageNo: pages.pageNo, pageSize: pages.pageSize });
    } catch (e) {
      // LzMsg.error(e.message);
      console.log(e)
    }
  };

  // const handlePageSizeChange2 = async (pages: object = {}) => {
  //   try {
  //     await getTableOne({ pageNo: pages.pageNo, pageSize: pages.pageSize });
  //   } catch (e) {
  //     // LzMsg.error(e.message);
  //     console.log(e)
  //   }
  // };

  const searchAll = async () => {
    await getSummaryOne();
    // await getSummaryTwo();
    // await getSummaryThree();
    await getTableOne({pageNo: 1, pageSize: pageInfo1.pageSize});
    // await getTableTwo();
  };

  const exportExl = () => {
    if(table1.length > 0) {
      Servlets('exportOrderCareSummaryDetail', {
        taskType: 'S_DDCF',
        startTime: startTime ? moment(startTime).startOf('day').valueOf() : '',
        endTime: endTime ? moment(endTime).endOf('day').valueOf() : '',
        taskId,
      }).then((res) => {
        utils.downloadFile(res);
      })
    } else {
      LzMsg.error('数据为空，请切换查询条件后重试');
    }
  };

  useEffect(() => {
    searchAll();
  }, []);

  useImperativeHandle(ref, () => ({
    interfaceSearch: () => {searchAll()},
  }));

  return <div className={styles['ddcf-summary']}>
    <div className={styles.btn}>
      <Button type='primary' onClick={() => exportExl()}>导出明细数据</Button>
    </div>
    <div className={styles['border-box']}>
      <div className={styles.title}>统计时间内的所有订单效果数据</div>
      <div className={styles['panel-summary']}>
        {/* 本来应该都写成组件的，没注意到所有key都一样，既然着急上线，那就着急写了 */}
        <DataBox title="已催付的订单总数 / 笔" value={data1.careNum} />
        <DataBox title="成功挽回的订单数 / 笔" value={data1.payNum} />
        <DataBox title="成功挽回的订单金额 / 元" value={data1.payAmount} />
        <DataBox title="催付成功率" value={data1.successRate} />
        <DataBox title="ROI" value={data1.roi} />
      </div>
    </div>

    <div className={styles['border-box']}>
      {/* <div className={styles.title}>统计时间内的普通订单效果数据</div>
        <div className={styles['panel-summary']}>
          <DataBox title="已催付的订单总数 / 笔" value={1} />
          <DataBox title="成功挽回的订单数 / 笔" value={2} />
          <DataBox title="成功挽回的订单金额 / 元" value={2} />
          <DataBox title="催付成功率" value={2} />
          <DataBox title="ROI" value={2} />
        </div> */}
      <div style={{ marginTop: 20 }}>
        <div className={styles.title}>统计时间内的每日效果数据</div>
        <TableBox loading={tableLoading1} dataSource={table1} />
        <LzPagination pageInfo={pageInfo1} onChange={handlePageSizeChange1} />
      </div>
    </div>

    {/* <div className={styles['border-box']}>
        <div className={styles.title}>统计时间内的货到付款订单效果数据</div>
        <div className={styles['panel-summary']}>
          <DataBox title="已催付的订单总数 / 笔" value={1} />
          <DataBox title="成功挽回的订单数 / 笔" value={2} />
          <DataBox title="成功挽回的订单金额 / 元" value={2} />
          <DataBox title="催付成功率" value={2} />
          <DataBox title="ROI" value={2} />
        </div>
        <div style={{marginTop: 20}}>
          <div className={styles.title}>统计时间内的每日效果数据</div>
          <TableBox loading={tableLoading2} dataSource={table2} />
          <LzPagination pageInfo={pageInfo2} onChange={handlePageSizeChange2} />
        </div>
      </div> */}
  </div>
};

export default forwardRef(ddcfSummary);
